module.exports = __webpack_public_path__ + "media/images/brands/marque-manucurist-cc08643a5d98ed593cc06cd7bbb82ecf.jpg";